import axios from "../axios/axios";
import { setRoles } from "../store/actions/roleAction";
import { errorDispatcher, setSelectItemLabels } from "../helpers";
import { appSetAlert, appSetLoading } from "store/actions/appAction";
import { setPermissions } from "store/actions/permissionAction";

export const apiGetRoles = (token) => (dispatch, getState) => {
  axios
    .get("roles", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      const roles = setSelectItemLabels(response.data.role, "id", "fa_title");
      dispatch(setRoles(roles));
    })
    .catch((error) => {
      dispatch(appSetAlert(error?.response?.data?.message,"error"))
      errorDispatcher(error, dispatch, false);
    });
};

export const apiSaveRole = (token, data, cb) => (dispatch, getState) => {
  axios
    .post("roles", data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(appSetAlert(response.data.message,"success"))
      cb && cb(response.data);
    })
    .catch((error) => {
      dispatch(appSetAlert(error?.response?.data?.message,"error"))
      errorDispatcher(error, dispatch, false);
    });
};
export const apiUpdateRole = (token, id, data, cb) => (dispatch, getState) => {
  axios
    .put(`roles/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(appSetAlert(response.data.message,"success"))
      cb && cb(response.data);
    })
    .catch((error) => {
      dispatch(appSetAlert(error?.response?.data?.message,"error"))
      errorDispatcher(error, dispatch, false);
    });
};

export const apiDeleteRoles = (token, id, cb) => (dispatch, getState) => {
  axios
    .delete(`roles/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(appSetAlert(response.data.message,"success"))
      cb && cb(response.data);
    })
    .catch((error) => {
      dispatch(appSetAlert(error?.response?.data?.message,"error"))
      errorDispatcher(error, dispatch, false);
    });
};

export const apiGetPermissions = (token, cb, dispatch, roleId) => {
  let url = `roles/permissions`
  dispatch(appSetLoading())
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
      params:{
        roleId: roleId
      }
    })
    .then((response) => {
      dispatch(appSetLoading(false))
      dispatch(setPermissions(response.data.permissions.permissions))
      cb && cb(response.data);
    })
    .catch((error) => {
      dispatch(appSetLoading(false))
      dispatch(appSetAlert(error?.response?.data?.message,"error"))
      dispatch && errorDispatcher(error, dispatch, false);
    });
};
